//import Alpine from 'alpinejs'
//Alpine.start()
import { initGallery } from './gallery';
import { global } from './global';
import mixitup from 'mixitup'

initGallery();
global();

